// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Videos_videos__pyO-5 .Videos_profile-video-card__v3xbx {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 5px;
  border-radius: 5px;
}
.Videos_videos__pyO-5 .Videos_profile-video-card__v3xbx .Videos_delete-video__KSLbT {
  margin-top: 5px;
}
.Videos_videos__pyO-5 .Videos_profile-video-card__v3xbx .Videos_delete-video__KSLbT svg {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.Videos_videos__pyO-5 .Videos_profile-video-card__v3xbx .Videos_delete-video__KSLbT svg path {
  stroke: red;
}
.Videos_videos__pyO-5 .Videos_add-button__itUjT {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Videos/Videos.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AACI;EACE,eAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAER;AADQ;EACE,WAAA;AAGV;AAEE;EACE,mBAAA;AAAJ","sourcesContent":[".videos {\n  .profile-video-card {\n    width: 100%;\n    background: white;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    padding: 5px;\n    border-radius: 5px;\n    .delete-video {\n      margin-top: 5px;\n      svg {\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n        path {\n          stroke: red;\n        }\n      }\n    }\n  }\n  .add-button {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videos": `Videos_videos__pyO-5`,
	"profile-video-card": `Videos_profile-video-card__v3xbx`,
	"delete-video": `Videos_delete-video__KSLbT`,
	"add-button": `Videos_add-button__itUjT`
};
export default ___CSS_LOADER_EXPORT___;
